import { create } from "zustand"

import { TransactionsModalData } from "./types"

interface TransactionModalStore {
	isOpen: boolean
	data: TransactionsModalData[]
	openModal: (data: TransactionsModalData[]) => void
	closeModal: () => void
}

export const useTransactionModalStore = create<TransactionModalStore>(set => ({
	isOpen: false,
	data: [],

	openModal: (data: TransactionsModalData[]) => set({ isOpen: true, data }),

	closeModal: () => set({ isOpen: false, data: [] }),
}))
